import React from 'react';
import {
  Box,
  Checkbox,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Typography
} from '@mui/material';
import "./PermissionsCheck.css";
import theme from 'config/theme';

const PermissionCheck = ({ titles, permissions, onChecked }) => {
  return (
    <Box width={'60%'} pl={4} mb={4}>
      <Typography
        bgcolor={theme.button.dark.backgroundColor}
        color={theme.button.dark.color}
        width={'100%'}
        textAlign={'center'}
        fontWeight={'bold'}
        py={1}
        sx={{
          borderTopLeftRadius: 8,
          borderTopRightRadius: 8
        }}
      >
        Permisos
      </Typography>
      <TableContainer >
        <Table
          size="small"
          aria-label="simple table"
        >
          <TableHead sx={{
            backgroundColor: theme.button.dark.backgroundColor,
          }}>
            <TableRow>
              <TableCell width={'30%'} ></TableCell>
              {
                titles.map((name, i) => (
                  <TableCell key={i} align="center" sx={{
                    color: theme.button.dark.color,
                    fontWeight: 'bold'
                  }} >{name}</TableCell>
                ))
              }
            </TableRow>
          </TableHead>
        </Table>
      </TableContainer>
      <div style={{ overflow: 'auto', height: '50vh' }}>
        {
          permissions.map(({ name, permissions }, h) => (
            <TableContainer key={h} component={Paper}>
              <Table
                size="small"
                // sx={{ minWidth: 650 }}
                aria-label="simple table"
              >
                <TableHead>
                  <TableRow>
                    <TableCell colSpan={5}>{name}</TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {
                    permissions.map(({ id, name, actions }, i) => (
                      <TableRow
                        key={i}
                        sx={{ '&:last-child td, &:last-child th': { border: 0 } }}
                      >
                        <TableCell
                          className='table-th'
                          width={'27%'}
                          component="th"
                          scope="row"
                        >
                          {name}
                        </TableCell>
                        {
                          titles.map((name, i) => (
                            <TableCell key={i} className='table-th' align="center">
                              <Checkbox
                                checked={actions?.includes(name)}
                                onChange={() => onChecked(id, name, actions?.includes(name))}
                                inputProps={{ "aria-label": "controlled" }}
                              />
                            </TableCell>
                          ))
                        }
                      </TableRow>
                    ))
                  }
                </TableBody>
              </Table>
            </TableContainer>
          ))
        }
      </div>
    </Box>

  )
}

export default PermissionCheck